export default {
  namespaced: true,
  state: {
    loading: false,
    stackedScrollPrevent: 0
  },
  getters: {
    isLoading(state) {
      return state.loading
    },
  },
  mutations: {
    setLoading(state, payload) {
      state.loading = payload
    },
    PREVENT_SCROLL(state, payload) {
      state.stackedScrollPrevent++
      if (state.stackedScrollPrevent == 1) {
        document.body.style.overflow = 'hidden'
      }
    },
    ALLOW_SCROLL(state, payload) {
      state.stackedScrollPrevent--
      if (state.stackedScrollPrevent < 1) {
        document.body.style.overflow = 'auto'
      }
    },
    SET_LOADING(state, payload) {
      state.loading = payload
    },
  },
  actions: {},
};